import { collection, doc, onSnapshot } from 'firebase/firestore';
import { db } from '../config/firebase';
import { subscribeByComitentes } from './comitentesQueryService';

/*
 * Próximos vencimientos de los clientes. La proyección del SGC (cupones,
 * amortizaciones, cheques/pagarés MAV de hoy a 90 días) la escribe la Cloud
 * Function `syncAcreditacionesEsperadas`, un doc por comitente; acá solo se lee.
 * Las cauciones y pases tomadores archivados por el cierre viven en `vencimientos`.
 *
 * `comitentes` = null en modo staff (colección completa); en modo productor, su
 * padrón: las reglas exigen la consulta acotada por `nroComitente`.
 */
const COLLECTION = 'proximosVencimientos';
const META_COLLECTION = 'proximosVencimientosMeta';
const META_DOC = 'actual';
const VENCIMIENTOS_FINANCIACION_COLLECTION = 'vencimientos';

const subscribeColeccion = (collectionName, comitentes, onData, onError) => {
  if (Array.isArray(comitentes)) {
    return subscribeByComitentes(collectionName, comitentes, onData, onError);
  }
  return onSnapshot(
    collection(db, collectionName),
    (snapshot) => onData(snapshot.docs.map(d => ({ id: d.id, ...d.data() }))),
    (error) => {
      console.error(`proximosVencimientosService: error suscribiendo ${collectionName}:`, error);
      if (onError) onError(error);
    },
  );
};

/** Un doc por comitente con `eventos`, `desde`, `hasta` y `fechaCartera`. */
export const subscribeProximosVencimientos = (comitentes, onData, onError) =>
  subscribeColeccion(COLLECTION, comitentes, onData, onError);

/** Cauciones y pases tomadores ya archivados (las del día salen del proveedor de saldos). */
export const subscribeVencimientosFinanciacion = (comitentes, onData, onError) =>
  subscribeColeccion(VENCIMIENTOS_FINANCIACION_COLLECTION, comitentes, onData, onError);

/** Meta de la última corrida: fecha de cálculo, horizonte y fecha de cartera del SGC. */
export const subscribeProximosVencimientosMeta = (onData, onError) => onSnapshot(
  doc(db, META_COLLECTION, META_DOC),
  (snap) => onData(snap.exists() ? { id: snap.id, ...snap.data() } : null),
  (error) => {
    console.error('proximosVencimientosService.subscribeProximosVencimientosMeta failed:', error);
    if (onError) onError(error);
  },
);
